var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoFirstPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9611 2.37531L6.6411 9.69531C5.8511 10.2053 5.3811 11.0653 5.3811 12.0053C5.3811 12.9453 5.8511 13.8053 6.6411 14.3153L17.9611 21.6353C18.8211 22.1953 19.8711 22.2353 20.7711 21.7453C21.6711 21.2553 22.2111 20.3553 22.2111 19.3253L22.2111 4.67531C22.2111 3.65531 21.6711 2.74531 20.7711 2.25531C19.8711 1.76531 18.8211 1.80531 17.9611 2.36531L17.9611 2.37531Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.24097,
    y: 1.91406,
    width: 2.0603,
    height: 20.1716,
    rx: 1.03015
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoFirstPage);
export default __webpack_public_path__ + "static/media/go_first_page.d31608fbc6762a649f5ca30e3c897c89.svg";
export { ForwardRef as ReactComponent };